import { Component } from "react";
import AddCreditcardForm from "../AddCreditcardForm";
import RectButton from "../ui/button/RectButton";

import "./style.scss";

class AddCreditcardSectionBox extends Component {
    render() {
        return (
            <>
                <div className="section-box row add-creditcard">
                    <section className="add-box">
                        <div className="box">
                            <AddCreditcardForm />
                            <div className="row action">
                                <RectButton text="ADD CARD" onClick={this.props.onAddCard} />
                                <RectButton text="CANCEL" onClick={this.props.onCancel} />
                            </div>
                        </div>
                    </section>
                    <section className="empty-section"></section>
                </div>
            </>
        )
    }
}
export default AddCreditcardSectionBox;